/**
 * PURPOSE: Confirmar "Oficializar" una prueba con la vista previa de su clasificación.
 * RESPONSIBILITIES: Mostrar `standings` (puesto, participante, marca, puntos, medalla) tal como los
 *   devolvió el servidor, avisar si quedan series sin terminar y confirmar.
 * COLLABORATORS: PruebaDetailPanel.jsx, PruebaStandingsTable.jsx.
 * ROUTE: winscore/src/area/AtletismoResultadosArea/components/OfficializeModal.jsx
 */
import React from "react";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import ModalClose from "@mui/joy/ModalClose";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import Button from "@mui/joy/Button";
import { FiAlertTriangle } from "react-icons/fi";

import PruebaStandingsTable from "./PruebaStandingsTable.jsx";
import { Spinner } from "./ui.jsx";

const OfficializeModal = ({ open, prueba, standings, rounds, loading, onCancel, onConfirm }) => {
  const unfinished = (Array.isArray(rounds) ? rounds : []).filter((round) => round.status !== "done");
  return (
    <Modal open={Boolean(open)} onClose={loading ? undefined : onCancel}>
      <ModalDialog sx={{ width: "min(96vw, 760px)", maxHeight: "90vh", borderRadius: "16px", overflow: "auto" }}>
        <ModalClose disabled={loading} />
        <DialogTitle>Oficializar · {prueba?.label || prueba?.name}</DialogTitle>
        <DialogContent>
          <p className="text-sm leading-6 text-slate-600">
            Revisa la clasificación. Al oficializar, la prueba queda bloqueada para edición y, si su
            visibilidad lo permite, se publica como oficial en Hayllis 2.0.
          </p>
          {unfinished.length ? (
            <p className="mt-2 flex items-start gap-2 rounded-lg bg-amber-50 px-3 py-2 text-xs font-semibold text-amber-800">
              <FiAlertTriangle className="mt-0.5 shrink-0" aria-hidden="true" />
              Hay {unfinished.length === 1 ? "una serie" : `${unfinished.length} series`} sin marcar como
              terminada: {unfinished.map((round) => round.label).join(", ")}.
            </p>
          ) : null}
          <div className="mt-3 rounded-xl border border-slate-200">
            <PruebaStandingsTable standings={standings} emptyLabel="El servidor aún no devolvió clasificación para esta prueba." />
          </div>
        </DialogContent>
        <div className="mt-3 flex justify-end gap-2">
          <Button variant="plain" color="neutral" onClick={onCancel} disabled={loading}>
            Cancelar
          </Button>
          <Button
            variant="solid"
            color="success"
            onClick={onConfirm}
            disabled={loading}
            startDecorator={loading ? <Spinner /> : null}
          >
            {loading ? "Oficializando..." : "Oficializar"}
          </Button>
        </div>
      </ModalDialog>
    </Modal>
  );
};

export default OfficializeModal;
